import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
const enableDebug = import.meta.env.VITE_IS_DEBUG;

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: enableDebug,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      wait: false,
      withRef: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
    resources: {
      en: {
        ImportStatus: {
          "pending": "Pending",
          "processing": "Processing",
          "unmapped": "Unmapped",
          "mapped": "Mapped",
          "optivised": "Optivised",
          "failed": "Failed",
          "unknown": "Unknown",
        },
        FIDO: {
          fidoKey: {
            registeredSuccess: "Passkey registered successfully",
            keyAdded: "Your passkey has been added",
            fetchError: "Error fetching passkeys",
            deletedSuccess: "Passkey deleted successfully",
            keyRemoved: "Passkey removed",
            deleteError: "Error deleting passkey",
            lastUsed: "Last used",
            created: "created",
            actions: {
              add: "Add passkey",
              remove: "Remove passkey",
            },
            title_passkeys: "Passkeys",
          },
          registerError: "Error registering passkey",
        },
        Auth: {
          name_placeholder: "John Doe",
          email_placeholder: "doe@example.com",
          register: "Register",
          name: "Name",
          current_password: "Current password",
          new_password: "New password",
          change_password: "Change password",
          title: "Login to Optivise",
          invalid_email: "Invalid email",
          invalid_password: "Password should include at least 8 characters",
          login_failed: "Login failed",
          incorrect_user_or_password: "Incorrect user or password",
          rate_limit_exceeded:
            "Too many login attempts. Please try again later.",
          unexpected_error: "An unexpected error has occurred: ",
          email: "Email",
          password: "Password",
          your_password: "Your password",
          forgot_password: "Forgot password?",
          login: "Login",
          // forgot pw:
          you_are_logged_in: "You are logged in",
          password_reset_requested: "Password reset requested",
          password_reset_requested_message:
            "Please check your email and follow the reset link to set a new password.",
          recover_password: "Recover password",
          request_reset_email: "Send recovery email",
          login_instead: "Login instead",
        },
        Users: {
          add_user: "Add user",
          email: "Email",
          first_name: "First name",
          last_name: "Last name",
          role: "Role",
          created: "Created",
          is_active: "Active",
          user_deleted: "User deleted!",
          invite_user: "Invite user",
          invitation_sent: "Invitation sent!",
          invite_user_info:
            "This will send an invitation to the user so they can join you to collaborate. Users can choose to login via a different login than email, but an email is required for the invitation.",
          save: "Save",
        },
        translation: {
          error_fallback: {
            title: "Something went wrong",
            message:
              "Sorry about that! Our team has been notified and will look into the error.",
            reload: "Reload page",
          },
          modal: {
            generic: {
              title: "Confirm",
              message: "Are you sure?",
              action_confirm: "Confirm",
              action_cancel: "Cancel",
            },
            delete: {
              title: "Delete",
              message:
                "Are you sure you want to delete this item? This action cannot be undone.",
              action_confirm: "Delete",
              action_cancel: "Cancel",
            },
          },
          upload: {
            failed: "Upload failed!",
            duplicate: "Duplicate, ignored",
            drag_files_here: "Drag files here or click to select files",
            size_limit:
              "Upload document files, the files must not exceed 100MiB individually",
            rejected_title: "Some files failed to upload",
            rejected_message: "Files had incorrect type or were too large",
            errors: {
              file_too_large: "Too large",
              file_invalid_type: "Invalid type",
            },
          },
          generic: {
            action_cancel: "Cancel",
            action_save: "Save",
            logout: "Log out",
            learn_more: "Learn more",
            last_name: "Last name",
            first_name: "First name",
            email: "Email",
            tags: "Tags",
            role: "Role",
            error: "An error occurred!",
            yesTitle: "Yes",
            noTitle: "No",
            goBack: "Back",
          },
          navbar: {
            home: "Home",
            logout: "Logout",
            login: "Login",
            users: "Users",
            tenants: "Tenants",
          },
          settings: {
            organization_settings: "Organization settings",
            select_interface_language: "Select interface language",
            select_content_languages: "Select content languages",
            select_current_timezone: "Current timezone",
            personal_settings: "Personal settings",
            profile: "Profile",
            pick_timezone: "Pick a timezone",
            changes_saved: "Changes saved",
            changes_saved_message: "Your profile changes have been saved",
          },
        },
      },
    },
  });

export default i18n;
